import { render, staticRenderFns } from "./CreateGameButton.vue?vue&type=template&id=598267b9"
import script from "./CreateGameButton.vue?vue&type=script&lang=js"
export * from "./CreateGameButton.vue?vue&type=script&lang=js"
import style0 from "./CreateGameButton.vue?vue&type=style&index=0&id=598267b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports